// import cssCard from "../OrderListItem/OrderListItem.module.scss";
import React from 'react';
import { Card, CardContent } from '@greeter/matter';
import css from './EmptyOrderlistDefaultMessage.module.scss';

export const EmptyOrderlistDefaultMessage: React.FC = ({}) => {
  return (
    <Card className={css.Card}>
      <CardContent className={css.CardContent}>
        <div className={css.EmptyOrderlistDefaultMessage}>
          <div className={css.Title}>
            Ingen aktuelle bookinger at vise
          </div>
          <div className={css.Description}>
            Prøv at oprette spændende events, som gæster kan bestille bord til.
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
